<div class="gantt-legend">
  <sc-flex >
    <div class="legend-entry planned">{{'Planned' | translate: ['reporting.gantt.legend.planned', translationService.language]}}</div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry arrived-not-started">{{'Angekommen, nicht gestartet' | translate: ['reporting.gantt.legend.arrived-not-started', translationService.language]}}</div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry processing">{{'In Bearbeitung' | translate: ['reporting.gantt.legend.processing', translationService.language]}}</div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry canceled">{{'Storniert' | translate: ['reporting.gantt.legend.canceled', translationService.language]}}</div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry finished">{{'Beendet' | translate: ['reporting.gantt.legend.finished', translationService.language]}}</div>
  </sc-flex>
</div>

